import { render, staticRenderFns } from "./AttachmentBtnGroup.vue?vue&type=template&id=4612b452&scoped=true&"
import script from "./AttachmentBtnGroup.vue?vue&type=script&lang=js&"
export * from "./AttachmentBtnGroup.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentBtnGroup.vue?vue&type=style&index=0&id=4612b452&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4612b452",
  null
  
)

export default component.exports